import { Avatar, Layout, Menu, MenuProps, Skeleton, Typography, message } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MENU_LOGOUT, MENU_ROLE } from "../../constants/menu";
import { UserContext } from "../../context/userContext";
import { generateAvatarColor } from "../../functions/function";
import { color } from "../../res/color";
import { PATHNAME } from "../../res/pathName";
import { POST } from "../../services";
import { AUTH_LOGOUT } from "../../services/path";

export const MyMenu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [mobile, setMobile] = useState<any>(undefined);
  const navigate = useNavigate();
  const { Sider } = Layout;

  useEffect(() => {
    const handleResize = () => {
      setCollapsed(window.innerWidth <= 800);
      setMobile(window.innerWidth <= 450 ? "0" : undefined);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await POST(AUTH_LOGOUT, {});
      localStorage.removeItem("batchID");
      localStorage.removeItem("skuData");
      localStorage.removeItem("ref_otp");
      localStorage.removeItem("isConfirmNoItem");
      setUser(null);
      navigate(PATHNAME.LOGIN);
      message.info("ออกจากระบบสำเร็จ");
    } catch (error) {
      console.error(error);
      message.error("ออกจากระบบล้มเหลว");
    }
  };

  if (user === null) {
    return <Skeleton active />;
  } else {
    const role = user.role_id;
    const menu = MENU_ROLE[role];
    const onClick: MenuProps["onClick"] = (e) => {
      const { key } = e;
      window.location.replace(key);
    };

    return (
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        style={{ background: color.WHITE }}
        collapsedWidth={mobile}
      >
        <div>
          <img
            src={process.env.REACT_APP_FRONTEND_URL + "/logo_uplift_3.jpg"}
            style={{ width: "100%", objectFit: "cover" }}
            alt={process.env.REACT_APP_FRONTEND_URL + "/logo_uplift_3.jpg"}
          />
          {!collapsed && (
            <div
              style={{
                marginTop: "5%",
                marginBottom: "5%",
                textAlign: "center", // Center-align the text container
                display: "flex", // Display items in a row
                alignItems: "center", // Vertically align items in the center
              }}
            >
              <Avatar
                size={40} // Adjust the size here
                style={{
                  backgroundColor: generateAvatarColor(user.username), // Use the generated color
                  marginLeft: "10%", // Use percentage-based margin
                  marginRight: "5%", // Use percentage-based margin
                }}
              >
                {user.username.charAt(0).toUpperCase()}
              </Avatar>
              <Typography
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "1.125em", // Use em units for responsiveness
                }}
              >
                {user.username}
              </Typography>
            </div>
          )}

          <Menu
            onClick={onClick}
            mode={"inline"}
            items={menu}
            defaultOpenKeys={["sub1", "sub2", "sub3", "sub4", "sub5"]}
            defaultSelectedKeys={[window.location.pathname]}
            style={{ flexGrow: 1, marginBottom: 50 }}
          />
          <Menu
            onClick={handleLogout}
            mode="inline"
            items={MENU_LOGOUT}
            style={{ borderTop: "1px solid #f0f0f0" }}
          />
        </div>
      </Sider>
    );
  }
};
